<template>
    <div>
        <div class="container">
            <div class="handle-box">
                <el-select v-model="location_type" class="handle-select mr10" @change="selectHandle">
                    <el-option
                      v-for="(child, index) in location_types"
                      :key="index"
                      :label="child.name" :value="child.id"></el-option>
                </el-select>
                <el-input v-model="keyword" placeholder="请输入机构名" class="handle-input mr10"></el-input>
                <el-button type="primary" icon="el-icon-search mr10" @click="handleSearch">搜索</el-button>
                <el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-add"
                    @click="addEdit"
                >新增</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                v-loading="loading"
            >
                <el-table-column label="序号" align="center" width="50">
                    <template slot-scope="scope">
                        <span>{{scope.$index+1}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="logo" align="center" width="200">
                    <template slot-scope="scope">
                        <el-image
                            class="table-td-thumb"
                            :src="scope.row.logo"
                            :preview-src-list="[scope.row.logo]"
                        ></el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="uuid" label="uuid" align="center"></el-table-column>
                <el-table-column prop="name" label="机构名" align="center"></el-table-column>
                <el-table-column label="类型" align="center">
                    <template slot-scope="scope">
                        {{getProviderName(scope.row.type)}}
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="200" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.row)"
                        >修改</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            @click="handleDelete(scope.row)"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination" v-if="totalPages > 1">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :current-page="currentPage"
                    :page-size="page_size"
                    :page-count="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <el-dialog :visible.sync="editVisible" width="50%" :close-on-click-modal="false">
            <el-form ref="ruleForm" :model="form" :rules="rules" label-width="120px">
                <el-form-item label="uuid：" prop="uuid">
                    <el-input
                     v-model="form.uuid" @input="onInput()"></el-input>
                </el-form-item>
                <el-form-item label="机构名：" prop="name">
                    <el-input
                     v-model="form.name" @input="onInput()"></el-input>
                </el-form-item>
              <el-form-item label="手机号：" prop="mobile">
                    <el-input
                     v-model="form.mobile" @input="onInput()"></el-input>
                </el-form-item>
                <el-form-item label="类型：" prop="type" v-show="is_add">
                    <el-select v-model="provider_type" class="handle-select">
                        <el-option
                        v-for="(child, index) in providerTypes"
                        :key="index"
                        :label="child.name" :value="child.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="logo：" prop="logo">
                    <el-upload
                    class="avatar-uploader"
                    action
                    :show-file-list="false"
                    :before-upload="beforeAvatarUpload"
                    >
                        <img v-if="form.logo" :src="form.logo" class="avatar" alt="加载失败"/>
                        <em v-show="!form.logo && !uploading" class="el-icon-plus avatar-uploader-icon"></em>
                        <em class="el-icon-loading avatar-uploader-icon" v-show="uploading"></em>
                    </el-upload>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer self-dialog-footer">
                <el-button type="primary" @click="saveEdit('ruleForm')">提 交</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {_} from 'vue-underscore';
import http from '../../../api/dorisApiConfig'
import http2 from '../../../api/uploadApiConfig'
export default {
    name: 'Providerlist',
    data() {
        return {
            location_types: [
                {"name": "全部", "id": ''},
                {"name": "颗粒", "id": 1},
                {"name": "饮片", "id": 2}
            ],
            location_type: '',
            keyword: '',
            providerTypes: [
                {"name": "颗粒", "id": 1},
                {"name": "饮片", "id": 2}
            ],
            provider_type: 1,
            tableData: [],
            currentPage: 1,
            totalPages: 1,
            page_size: 10,
            pageTotal: 10,
            page_index: 10,
            loading: false,
            imageUrl: '',
            multipleSelection: [],
            editVisible: false,
            is_add: false,
            uploading: false,
            form: {},
            rules: {
                uuid: [{ required: true, message: "请填写uuid", trigger: "blur" }],
                name: [{ required: true, message: "请填写机构名", trigger: "blur" }],
              mobile: [{ required: true, message: "请填写手机号", trigger: "blur" }]
                // logo: [{ required: true, message: "请上传logo", trigger: "blur" }]
            }
        };
    },
    created() {
        this.getData();
    },
    methods: {
        formatDate(time){
            return new Date(time*1000).Format('YYYY-MM-DD hh:mm:ss');
        },
        getProviderName(id){
            var item = _.filter(this.providerTypes, function(selector){ return selector.id == id; })[0];
            if(item){
                return item['name'];
            }else{
                return '';
            }
        },
        getData() {
            let that = this;
            that.loading = true;
            let params = {
                page: that.currentPage,
                page_size: that.page_size
            }
            if(that.keyword){
                params["name"] = that.keyword;
            }
            if(that.location_type){
                params["type"] = that.location_type;
            }
            http.get("admin/providers",{params: params}).then(function(res) {
                that.tableData = res.data.data.providers;
                that.currentPage = res.data.data.current_page;
                that.totalPages = res.data.data.total_pages;
                that.loading = false;
            });
        },
        //选择
        selectHandle(){
            this.currentPage = 1;
            this.getData();
        },
        // 触发搜索按钮
        handleSearch() {
            this.currentPage = 1;
            this.getData();
        },
        beforeAvatarUpload(file) {
            let that = this;
            const isJPG = file.type === "image/jpeg" || "image/png";
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (isJPG && isLt2M) {
                var ossData = new FormData();
                let imgType = file.type.split("/")[1];
                var filename = file.name.split(".")[0] + "." + imgType;
                ossData.append("work_path", "common/provider");
                ossData.append("bucket", "family-tcm");
                ossData.append("end_point", "oss-cn-hangzhou.aliyuncs.com");
                ossData.append("rewrite", "1");
                ossData.append("file_name", filename);
                ossData.append("file", file);
                that.uploading = true;
                http2.post("upload", ossData).then(function(res) {
                    if (res.data.status_code == 200) {
                        that.imageUrl = "common/provider/" + filename;
                        that.form.logo = URL.createObjectURL(file);
                    }
                    that.uploading = false;
                });
            } else if (!isJPG) {
                this.$message.error("上传头像图片只能是 JPG 格式!");
            } else if (!isLt2M) {
                this.$message.error("上传头像图片大小不能超过 2MB!");
            }
            return isJPG && isLt2M;
        },
        // 删除操作
        handleDelete(row) {
            let that = this;
            // 二次确认删除
            that.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
            .then(() => {
                let params = {
                    provider_id: row.id
                }
                http.delete("admin/provider", {params: params}).then(function(res) {
                    // console.log(res);
                    if (res.data.status_code == 200) {
                        that.$message.success('删除成功');
                        that.getData();
                    }else{
                        that.$message.error(res.data.msg);
                    }
                });
            })
            .catch(() => {});
        },
        onInput(){
            this.$forceUpdate();
        },
        // 编辑操作
        handleEdit(row) {
            this.form = {
                provider_id: row.id,
                uuid: row.uuid,
                name: row.name,
              mobile: row.mobile,
                logo: row.logo
            };
            this.imageUrl = row.logo_path;
            if(row.type){
                this.provider_type = row.type;
            }else{
                this.provider_type = 1;
            }
            this.is_add = false;
            this.editVisible = true;
        },
        //新增操作
        addEdit(){
            this.form = {
                uuid: '',
                name: '',
                logo: '',
              mobile: '',

            }
            if(this.location_type == ''){
                this.provider_type = 1;
            }else{
                this.provider_type = this.location_type;
            }
            this.is_add = true;
            this.editVisible = true;
        },
        // 保存编辑
        saveEdit(formName) {
            let that = this;
            that.$refs[formName].validate(valid => {
                if (valid) {
                    let params = {
                        type: that.provider_type,
                        uuid: that.form.uuid,
                        name: that.form.name,
                        mobile: that.form.mobile,
                        logo: that.imageUrl
                    };
                    if(that.is_add){
                        http.post("admin/provider", params).then(function(res) {
                            // console.log(res);
                            if (res.data.status_code == 200) {
                                that.$message.success(`新增成功`);
                                that.getData();
                            }else{
                                that.$message.error(res.data.msg);
                            }
                        });
                    }else{
                        params['provider_id'] = that.form.provider_id;
                        http.put("admin/provider", params).then(function(res) {
                            // console.log(res);
                            if (res.data.status_code == 200) {
                                that.$message.success(`修改成功`);
                                that.getData();
                            }else{
                                that.$message.error(res.data.msg);
                            }
                        });
                    }
                    that.editVisible = false;
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        // 分页导航
        handlePageChange(val) {
            this.currentPage = val;
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 180px;
}
.self-dialog-footer{
    display: block;
    text-align: center;
}
.avatar {
    height: 178px;
    display: block;
    max-width: 100%;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
</style>
